/* jade-v2-core.js · the shared runtime of the Jade v2 page (package C). Defines window.SSD (contract 3.4).
   Ported from v5's d-core.js. Kept: the reduced-motion / Save-Data flags, the html.d-anim gate with its fail-open watchdog,
   the reveal observer, the measurement hooks (SSD.track), and the shared tier store. Dropped: GSAP, Lenis, the toast,
   the typed prototype prices and ?reduce / ?nogsap.
   MONEY: this file never adds to the cart itself and never formats a price. The tier store is bound to the REAL pack radios
   (#packs input[name=id], rendered by snippets/jade-v2-buy.liquid); prices, labels, delivery notes and availability are
   read from their data-* attributes. SSD.add() hands the selected variant to assets/pdp-atc.js, the theme's one add writer
   (window.SacrasoulPdpAdd); it opens no second fetch. If that writer is not on the page, it submits the real form instead,
   which the inline guard in the buy snippet lets through exactly when the writer is absent. */
(function () {
  'use strict';
  /* ?jv2perf=1 loads the frame meter (jade-v2-perf.js); else nothing */
  (function () { var me = document.currentScript, src = me && me.getAttribute('data-perf');
    if (src && /[?&]jv2perf=1/.test(location.search)) { var s = document.createElement('script'); s.src = src; s.async = true; document.head.appendChild(s); } })();

  var w = window, d = document, h = d.documentElement;
  if (w.SSD && w.SSD.__jv2) return; /* a second script tag must not boot a second store */

  /* The page's held screen unit (--sv/--lv) and short-screen classes (d-h720/760/820) are set by sections/jade-v2-story.liquid. */

  var qs = new URLSearchParams(location.search);
  var conn = navigator.connection || {};
  var reduced = qs.get('jv2reduce') === '1' || matchMedia('(prefers-reduced-motion: reduce)').matches || conn.saveData === true;
  var fine = matchMedia('(pointer: fine)').matches && w.innerWidth >= 900;
  var TIERS = {}, tierCbs = [], readyCbs = [], lastKey = '', tierSeen = false;

  function radios() { return d.querySelectorAll('#packs input[name="id"][data-vid]'); }
  function info(r) {
    return {
      n: +r.getAttribute('data-n'), ml: +r.getAttribute('data-ml'), name: r.getAttribute('data-name') || '',
      count: r.getAttribute('data-count') || '', mlText: r.getAttribute('data-ml-text') || '',
      label: r.getAttribute('data-label') || '', priceText: r.getAttribute('data-price') || '',
      eachText: r.getAttribute('data-each') || '', saveText: r.getAttribute('data-save') || '',
      saveIn: r.getAttribute('data-save-in') || '', note: r.getAttribute('data-note') || '',
      variantId: r.getAttribute('data-vid'), available: !r.disabled, radio: r
    };
  }
  /* The map keeps its object identity: other modules hold SSD.TIERS and read it later. */
  function refresh() {
    var seen = {};
    Array.prototype.forEach.call(radios(), function (r) {
      var t = info(r); if (!t.n) return;
      seen[t.n] = 1; var cur = TIERS[t.n];
      if (cur) { for (var k in t) cur[k] = t[k]; } else TIERS[t.n] = t;
    });
    Object.keys(TIERS).forEach(function (k) { if (!seen[k]) delete TIERS[k]; });
  }
  /* the tier the shopper is on: the checked radio; with none checked, the first one that sells */
  function current() {
    var c = d.querySelector('#packs input[name="id"]:checked');
    if (c) return +c.getAttribute('data-n') || 0;
    var f = d.querySelector('#packs input[name="id"]:not([disabled])') || d.querySelector('#packs input[name="id"]');
    return f ? +f.getAttribute('data-n') || 0 : 0;
  }
  function key() { return Object.keys(TIERS).map(function (k) { return k + (TIERS[k].available ? '+' : '-'); }).join('') + ':' + current(); }

  function paint() {
    var n = current(), t = TIERS[n]; if (!t) return;
    d.querySelectorAll('[data-d-price]').forEach(function (e) { if (e.textContent !== t.priceText) e.textContent = t.priceText; });
    d.querySelectorAll('[data-d-tier-name]').forEach(function (e) { e.textContent = t.name; });
    d.querySelectorAll('[data-d-tier-label]').forEach(function (e) { if (e.textContent !== t.label) e.textContent = t.label; });
    d.querySelectorAll('[data-d-each]').forEach(function (e) { e.textContent = t.eachText; e.hidden = !t.eachText; });
    /* the CHOOSE box (and any other mirror) carries input[name=d-tier]: keep it on the store's tier, and dead where the tier is sold out */
    d.querySelectorAll('input[name="d-tier"]').forEach(function (r) {
      var rt = TIERS[+r.value]; r.checked = (+r.value === n);
      if (rt) r.disabled = !rt.available;
    });
  }
  function notify() {
    refresh(); paint(); lastKey = key();
    var n = current(), t = TIERS[n];
    tierCbs.slice().forEach(function (cb) { try { cb(n, t); } catch (err) { if (w.console) console.error(err); } });
  }

  var SSD = w.SSD = {
    __jv2: true,
    reduced: reduced, fine: fine, animated: false, TIERS: TIERS,
    onReady: function (fn) { if (SSD._ready) { try { fn(); } catch (err) { if (w.console) console.error(err); } } else readyCbs.push(fn); },
    tier: {
      get: function () { return current(); },
      /* check the matching REAL radio and fire its change, so pdp-atc.js repaints #atcprice and #sbprice; a sold-out or
         missing tier changes nothing and answers false */
      set: function (n) {
        n = +n; refresh(); var t = TIERS[n];
        if (!t || !t.radio || t.radio.disabled) { paint(); return false; }
        if (!t.radio.checked) { t.radio.checked = true; t.radio.dispatchEvent(new Event('change', { bubbles: true })); }
        return true;
      },
      on: function (cb) { tierCbs.push(cb); var n = current(); if (TIERS[n]) cb(n, TIERS[n]); }
    },
    /* the ONE way any surface on this page adds the selected tier: through the theme's add writer */
    add: function (surface) {
      refresh(); var t = TIERS[current()];
      if (!t || !t.radio || t.radio.disabled) return false;
      SSD.track('atc_click', { where: surface || 'hero', tier: t.n });
      if (typeof w.SacrasoulPdpAdd === 'function') { w.SacrasoulPdpAdd(t.variantId); return true; }
      var f = t.radio.form, b = d.getElementById('atc');
      if (!f) return false;
      if (f.requestSubmit) { try { f.requestSubmit(b && !b.disabled ? b : undefined); return true; } catch (err) {} }
      f.submit(); return true;
    },
    /* reveal: mark elements with .d-rv (and optional style="--i:N" for a 50ms stagger). */
    reveal: function (root) {
      var els = (root || d).querySelectorAll('.d-rv:not(.d-in)');
      if (!('IntersectionObserver' in w)) { els.forEach(function (e) { e.classList.add('d-in'); }); return; }
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('d-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      els.forEach(function (e) { io.observe(e); });
    },
    smooth: function () { return null; } /* v5's Lenis hook, kept as a no-op so a module that asks for it gets nothing */
  };

  /* ── PICTURES (SSD.pics): one queue for every picture, in the order the reader meets them ──
     4 Oct, 2 Mbps: each module fetched on its own trigger, so steam, the case, its frames and the scent tiles started
     together while the story's last scenes were still arriving. Each
     picture has `at`, the scroll where it first shows (a flow picture's top less a screen; owners of pinned ones say
     theirs). At most 3 requests open, nearest first; near = within 4 screens (4 s of a fast thumb, up to 8); decoded
     within 2.5 (2.5 s, up to 6). Nothing near in flight: the next ones in order, 2 at a time, low priority, after the hero
     (not under Save-Data or 2g), down to 12 screens past the furthest the reader has been, or 4 s at their fastest pace
     (sampled >= 250 ms apart, so one swipe is not read as a flick), as ss-image-warm.js does for the rest of the site.
     Until 1 Nov this lane fetched the whole page, ~2.4 MB on a phone, while half of PL phone readers leave within the first
     screen. 12, not 8: on a 1.6 Mbps line a reader who rested 10 s and then flicked met ~15 stills a run arriving 0.5-0.8 s
     late at 8 screens (the steam stills and closing scenes, 13-19 screens down), none at 12 (n=6), for 1.06 MB saved
     instead of 1.43. Soft feeds (the case's frames, 1.3 MB on a phone) queue 4 screens late, yield to any
     picture waiting within reach, a lane per request. ss-image-warm.js leaves [data-pics] alone; its sweep waits for ss:pics-idle while html[data-pics-busy],
     which ends once nothing is in flight and nothing is left within reach.
     Lazy to eager keeps srcset/sizes; no JS: native lazy. gate: a picture with no loader of its own stays at opacity 0
     until decoded, then fades in over its box's colour. */
  SSD.pics = (function () {
    var Q = [], n = 0, open = 0, far = 0, y = 0, vh = w.innerHeight, ahead = 4 * vh, dw = 2.5 * vh, deep = 0, reach = 12 * vh, ry = -1, rt = 0, ly = 0, lt = 0, live = false, tq = 0,
      thin = conn.saveData || /(^|[^3-9])2g/.test(conn.effectiveType || '');
    function seen(el) { return el.complete && (el.naturalWidth > 0 || /^data:/.test(el.currentSrc || '')); }
    function measure() {
      vh = w.innerHeight; var sy = w.scrollY;
      Q.forEach(function (it) { if (it.fix == null) { var r = (it.el || it.box).getBoundingClientRect(); it.at = r.width || r.height ? r.top + sy - vh : 1e8; } });
    }
    function key(it) { var a = it.fix != null ? it.fix : it.at; a += it.soft ? 4 * vh : 0; return a < y - 3 * vh ? 1e9 + a : a; }
    function decode(it) {
      var el = it.el; if (it.dec || !el || !seen(el)) return; it.dec = 1;
      var show = function () { if (el.style.opacity !== '0') return; if (!reduced) el.style.transition = 'opacity .3s ease-out'; el.style.opacity = ''; };
      if (el.decode && !/^data:/.test(el.currentSrc || '')) el.decode().then(show, show); else show();
    }
    function pic(el, opt) {
      if (!el || el.__pk || (!el.getAttribute('src') && !el.getAttribute('srcset'))) return;
      var it = el.__pk = { el: el, i: n++, fix: opt && opt.at, soft: opt && opt.soft, done: seen(el) || el.complete };
      el.setAttribute('data-pics', '');
      if (opt && opt.gate && !it.done) el.style.opacity = '0';
      function fin() { var b = it.busy; it.busy = 0; if (b) b(); it.done = true; if ((it.fix != null ? it.fix : it.at) - y < dw) decode(it); pump(); }
      el.addEventListener('load', fin); el.addEventListener('error', fin);
      /* already requested by the markup (eager): it holds a lane until it lands */
      if (!it.done && !el.complete && el.loading !== 'lazy') { open++; it.busy = function () { open--; }; }
      Q.push(it); return it;
    }
    function start(it, near) {
      open++; if (!near) far++;
      var free = function () { open--; if (!near) far--; }, el = it.el;
      if (it.feed) { /* a feed holds one lane per request */
        var p = it.feed(near);
        if (!p) { free(); it.done = true; } else p.then(null, function () {}).then(function () { free(); pump(); });
        return;
      }
      it.busy = free;
      if (!el.getAttribute('fetchpriority')) el.fetchPriority = near ? 'high' : 'low';
      el.loading = 'eager';
      if (el.complete) { it.busy = 0; free(); it.done = true; if (seen(el)) decode(it); }
    }
    function pump() {
      if (!live) return;
      for (var guard = 0; open < 3 && guard < 60; guard++) {
        var best = null, bk = 2e9, sb = null, sk = 2e9, k, i, it;
        for (i = 0; i < Q.length; i++) {
          it = Q[i]; if (it.done || (it.busy && !it.feed)) continue; k = key(it);
          if (it.soft) { if (k < sk) { sk = k; sb = it; } } else if (k < bk || (best && k === bk && it.i < best.i)) { bk = k; best = it; }
        }
        /* a soft feed yields to any picture waiting within reach */
        if (sb && (!best || (sk < bk && bk - y >= ahead))) { best = sb; bk = sk; }
        if (!best) break;
        var near = bk - y < ahead;
        if (!near && (thin || far >= 2 || open > far || bk - deep >= reach)) break;
        start(best, near);
      }
      /* idle: all done, or nothing in flight and nothing within reach (ss-image-warm.js waits for this) */
      var left = Q.some(function (q) { return !q.done; });
      if ((!left || !open) && h.hasAttribute('data-pics-busy')) { h.removeAttribute('data-pics-busy'); d.dispatchEvent(new Event('ss:pics-idle')); }
    }
    /* after the frame (layout clean, so the read is free), at most every 120 ms while scrolling */
    function check() {
      tq = 0; var t = performance.now(); y = w.scrollY; deep = Math.max(deep, y);
      var v = lt ? Math.abs(y - ly) / Math.max(16, t - lt) * 1000 : 0; ly = y; lt = t;
      /* the far lane's reach: never shrinks; the pace is read over >= 250 ms, a fresh start after a second's rest */
      if (ry < 0 || t - rt > 1000) { ry = y; rt = t; } else if (t - rt >= 250) { reach = Math.max(reach, Math.abs(y - ry) / (t - rt) * 4000); ry = y; rt = t; }
      reach = Math.max(reach, 12 * vh);
      ahead = thin ? vh : Math.max(4 * vh, Math.min(8 * vh, v * 4)); dw = Math.max(2.5 * vh, Math.min(6 * vh, v * 2.5));
      Q.forEach(function (it) { if (it.done && !it.dec && it.el && (it.fix != null ? it.fix : it.at) - y < dw) decode(it); });
      pump();
    }
    function go() { if (live) return; live = true; measure(); check(); }
    var api = {
      pic: pic,
      /* an owner's own scroll position for a picture (the stage's scenes); registers it if needed */
      at: function (el, at, opt) {
        var it = el.__pk || pic(el, opt); if (!it) return;
        it.fix = at; if (opt && opt.gate && !it.done) el.style.opacity = '0';
        if (live) check();
      },
      /* next(near) starts one request and returns its promise, or null when the feed is done */
      feed: function (box, next, soft) { Q.push({ box: box, feed: next, soft: soft, i: n++ }); if (live) { measure(); pump(); } },
      measure: function () { measure(); if (live) check(); }
    };
    function boot() {
      var plain = '.d-use-img,.d-maker-fig img,.d-maker-echo img';
      d.querySelectorAll('.jv2 img').forEach(function (el) { pic(el, { gate: el.matches(plain) }); });
      h.setAttribute('data-pics-busy', '');
      /* the shell places its scenes first */
      var hero = d.querySelector('.d-scene--0 img');
      if (!hero || seen(hero)) setTimeout(go, 0); else { hero.addEventListener('load', go, { once: true }); hero.addEventListener('error', go, { once: true }); setTimeout(go, 4000); }
      w.addEventListener('scroll', function () { if (!live) go(); if (!tq) tq = setTimeout(check, 120); }, { passive: true });
      w.addEventListener('load', api.measure);
      w.addEventListener('resize', function () { clearTimeout(api.rt); api.rt = setTimeout(api.measure, 200); });
      if ('ResizeObserver' in w) { var mh = 0; new ResizeObserver(function () { var H = h.scrollHeight; if (Math.abs(H - mh) > 40) { mh = H; clearTimeout(api.rt); api.rt = setTimeout(api.measure, 300); } }).observe(d.getElementById('MainContent') || d.body); }
    }
    api.boot = boot;
    return api;
  })();

  /* PostHog pdp_story_<name> via ss-posthog.js; passive: no init wake */
  SSD.events = [];
  SSD.track = function (name, props) {
    var e = { name: name, props: props || {}, t: Math.round(performance.now()) };
    SSD.events.push(e);
    try { d.dispatchEvent(new CustomEvent('sacrasoul:behavior', { detail: { name: 'pdp_story_' + name, properties: e.props, passive: 1 } })); } catch (err) {}
  };

  function boot() {
    try { SSD.pics.boot(); } catch (err) { if (w.console) console.error(err); }
    refresh();
    /* the real radios are the source: a pick made anywhere lands here as a change on #packs */
    d.addEventListener('change', function (e) {
      var t = e.target; if (!t || t.type !== 'radio') return;
      if (t.name === 'id' && t.closest && t.closest('#packs')) { notify(); }
      else if (t.name === 'd-tier') { if (!SSD.tier.set(t.value)) paint(); }
    });
    /* pdp-atc.js disables a tier's radio when Shopify answers sold out; follow it */
    if ('MutationObserver' in w) {
      var mo = new MutationObserver(function () { refresh(); if (key() !== lastKey) notify(); });
      Array.prototype.forEach.call(radios(), function (r) { mo.observe(r, { attributes: true, attributeFilter: ['disabled'] }); });
    }
    /* pdp-atc.js may have moved the pick off a sold-out default after this file ran */
    w.addEventListener('load', function () { refresh(); if (key() !== lastKey) notify(); });
    /* the buttons pdp-atc.js owns: only measure the tap, never touch it */
    d.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('#atc,[data-sticky-add]');
      if (b) SSD.track('atc_click', { where: b.getAttribute('data-d-where') || (b.id === 'atc' ? 'hero' : 'sticky'), tier: current() });
    });
    SSD.tier.on(function (n) { if (tierSeen) SSD.track('tier_change', { tier: n }); tierSeen = true; });
    paint(); lastKey = key();
    SSD._ready = true; readyCbs.splice(0).forEach(function (fn) { try { fn(); } catch (err) { if (w.console) console.error(err); } });
    SSD.reveal();
    if ('IntersectionObserver' in w) {
      var seen = {};
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { var id = e.target.getAttribute('data-d-ch'); if (e.isIntersecting && id && !seen[id]) { seen[id] = 1; SSD.track('chapter_view', { chapter: id }); } }); }, { threshold: 0.35 });
      d.querySelectorAll('[data-d-ch]').forEach(function (n) { io.observe(n); });
    }
    /* scroll depth: scrollHeight and scrollY read in a scroll event force a style recalc + layout every frame; the read waits for
       the task after the frame (layout clean, free), once per frame, and the listener leaves once 100% is marked */
    var marks = { 25: 0, 50: 0, 75: 0, 100: 0 }, depthQ = false;
    function depth() {
      depthQ = false;
      var m = h.scrollHeight - w.innerHeight; if (m <= 0) return; var p = w.scrollY / m * 100;
      [25, 50, 75, 100].forEach(function (k) { if (!marks[k] && p >= k - (k === 100 ? 2 : 0)) { marks[k] = 1; SSD.track('scroll_depth', { pct: k, screens: +(w.scrollY / w.innerHeight).toFixed(1) }); } });
      if (marks[100]) w.removeEventListener('scroll', onDepth, { passive: true });
    }
    function onDepth() { if (!depthQ) { depthQ = true; setTimeout(depth, 0); } }
    w.addEventListener('scroll', onDepth, { passive: true });
  }

  /* animation gate: hidden initial states exist only while motion is allowed and the core is alive; the watchdog opens
     everything if the core has not booted, and a second one reveals anything already in view */
  if (!reduced) { h.classList.add('d-anim'); SSD.animated = true; }
  setTimeout(function () { if (!SSD._ready) { h.classList.remove('d-anim'); SSD.animated = false; } }, 2500);
  setTimeout(function () { d.querySelectorAll('.d-rv:not(.d-in)').forEach(function (e) { if (e.getBoundingClientRect().top < w.innerHeight * 1.2) e.classList.add('d-in'); }); }, 3200);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
